import createStaticRef from '../../../../Core/Helpers/createStaticRef'

const drawerProps = createStaticRef()

export default drawerProps
